export default {
  headings: {
    createCalendar: "Create a new Calendar",
    myCalendars: "My calendars",
    productName: "Activity management system",
  },
  captions: {
    copied: "Copied",
  },
  messages: {},
  options: {
    publicAccessibility: "Publish the calendar publicly",
    monthly: "Monthly",
    weekly: "Weekly",
    daily: "Daily",
  },
  placeholders: {
    calendarName: "Personal Calendar",
    description: "Enter the description ...",
    search: "Search for the phrase",
  },
  buttons: {
    createCalendar: "Create a new calendar",
    createEvent: "Create a new event",
    deleteCalendar: "Delete calendar",
    sharingLink: "Get a subscription link",
    cancel: "Cancel",
    deleteAllEvents: "Clear all events",
    save: "Save",
    calendarSetting: "Calendar setting",
    calendarSharing: "Share Calendar",
    today: "Today",
    gregorianCalendar: "Gregorian calendar",
    jalaliCalendar: "Jalali calendar",
  },
  labels: {
    calendarName: "Calendar Name",
    description: "Description",
    accessibility: "Accessibility",
    chooseColor: "Choose a calendar color",
    more:"more"
  },
  social: {},
  defaultValues: {},
  emptyState: {},
  notifications: {},
};
